export default __webpack_public_path__ + "static/media/tile_WXSnow.ae33ae5d.svg";